import React from 'react';
import { isNullOrUndefined } from 'utils/Global';
import CheckboxCustom from './CheckboxCustom';

function RMMultipleCheckboxes({
  checkboxs,
  onCheckboxChange,
  selectedValues,
  checkboxContainerStyle = {},
  labelClass = '',
}) {
  function getCheckboxView() {
    if (isNullOrUndefined(checkboxs)) {
      return null;
    }
    const checkBoxElems = [];
    for (let i = 0; i < checkboxs.length; i++) {
      const cb = checkboxs[i];
      const element = (
        <CheckboxCustom
          label={cb.name}
          value={''}
          checked={selectedValues.includes(cb.id)}
          id={cb.id}
          onClick={() => onCheckboxChange(cb.id)}
          labelClass={labelClass}
        />
      );
      checkBoxElems.push(element);
    }

    return checkBoxElems;
  }

  return (
    <div
      id="controls-rmmultiplecheckboxes-wrapper"
      data-testid="controls-rmmultiplecheckboxes-wrapper"
      style={{ height: '100%', overflow: 'auto', ...checkboxContainerStyle }}
    >
      {getCheckboxView()}
    </div>
  );
}

export default RMMultipleCheckboxes;
